import { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import ApiContext from "src/provider/API/call-service";
import { 
    AbsoluteContainer,
    AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, 
    GridContainer, ScreenContainer, ScreenTitle 
} from "src/style"
import utility from "src/utils/utility"
import { IoIosArrowBack } from "react-icons/io";
import { Company, Subsidiary } from 'src/model';
import {ReactComponent as SubscriptionIcon} from 'src/assets/svg/subscription-icon.svg';
import SubsidiaryDoc from 'src/assets/svg/subsidiary-doc.svg'
import { ServerSideTable, Table } from "src/component";
import {ReactComponent as NoUserIcon} from 'src/assets/svg/no-user-icon.svg'
import { subsidiariesColumn, subsidiariesData } from 'src/utils/tableLayout'
import helpers from "src/utils/helpers";

const CompanyDetails: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {selectedCompany}, setInfoProperty} = useContext(AppInfoContext)
    const [company, setCompany] = useState<Company>(selectedCompany)
    const [subsidiariesInfo, setSubsidiariesInfo] = useState<any>(null)
    const [subsidiaries, setSubsidiaries] = useState<Array<Subsidiary>|null>(null)
    const [navPosition, setNavPosition] = useState(0)

    useEffect(() => {
        if (selectedCompany?.name) {
            setCompany(selectedCompany)
            handleFetchSubsidiaries()
        }
    }, [selectedCompany])

    async function handleFetchSubsidiaries (pageNumber = 1, pageSize = 10) {
        // const data = await subsidiariesData()
        // setSubsidiaries(data)
        const response = await API.getSubsidiariesByOrganizationId({
            page: pageNumber, 
            size: pageSize,
            organizationId: company.id
        })
        if (response) {
            setSubsidiariesInfo(response)
            setSubsidiaries(response.data)
        }
    }

    async function handleSubsidiaryRowClick (data: Subsidiary, option: string) {
        await setInfoProperty('selectedSubsidiary', data.subsidiary)
        if (option === 'view-customers') navigate('/dashboard/customers')
        else navigate('/dashboard/subsidiaries/subsidiary-details')
    }

    async function handleRowClick (data: Subsidiary) {
        
    }

    return (
        <>
            <ScreenContainer padding='2.5'>
                <FlexRow 
                    gap="2" width="auto" 
                    sizeUnit="" bottomMargin='4'
                >
                    <GridContainer 
                        width="4" height="4" 
                        borderColor="#5627FF"
                        radius="0.4"
                        onClick={() => navigate(-1)}
                    >
                        <IoIosArrowBack color="#5627FF" fontSize='2.5rem' />
                    </GridContainer>
                    <CustomContainer 
                        height="4.9" 
                        width="0.1" 
                        borderColor="#E0E0E0" 
                    />
                    <CustomContainer width="auto" sizeUnit="">
                        <ScreenTitle 
                            color='#333333' 
                            textSize='2.4' 
                            fontWeight='700'
                        >
                            Company Details
                        </ScreenTitle>
                        <AppSpan color="#333333">Company &gt; Company Details</AppSpan>
                    </CustomContainer>
                </FlexRow>

                { company.hasSubsidiaries &&
                    <GridContainer
                        className='scrollable-container-plus toggle-border-bottom'
                        height="3.6" width='32.5'
                    >
                        <AbsoluteContainer 
                            width={navPosition === 0 ? '14' : '16'} 
                            top="0" left={`${navPosition}`}
                        >
                            <CustomContainer 
                                bgColor="#F0ECFF" height="3.6" 
                                borderBottomColor='#5627FF' borderWidth='4.5'
                            />
                        </AbsoluteContainer>
                        <FlexRow
                            alignItems='flex-start'
                            gap='1'
                            style={{zIndex: '2'}}
                        >
                            <GridContainer 
                                width='14' rightMargin='1.5' 
                                hoverBgColor={navPosition === 0 ? '' : '#F0ECFF'}
                                onClick={() => setNavPosition(0)}
                                className='toggled-item'
                            >
                                <AppSpan  
                                    cursor="pointer"
                                    fontWeight={navPosition === 0 ? "700" : "400"}
                                    color={navPosition === 0 ? "#181D27" : "#828282"}
                                >
                                    Company Details
                                </AppSpan>
                            </GridContainer>
                            <GridContainer 
                                width='15' rightMargin='1.5'
                                hoverBgColor={navPosition === 16 ? '' : '#F0ECFF'}
                                onClick={() => setNavPosition(16)}
                                className='toggled-item'
                            >
                                <AppSpan 
                                    cursor="pointer"
                                    fontWeight={navPosition === 16 ? "700" : "400"}
                                    color={navPosition === 16 ? "#181D27" : "#828282"}
                                >
                                    Subsidiaries
                                </AppSpan>
                            </GridContainer>
                        </FlexRow>
                    </GridContainer>
                }

                { navPosition === 0 ?
                    <FlexRow 
                        gap="2" justifyContent="space-between" 
                        alignItems="flex-start" topMargin="3"
                        className='dashboard-charts-container'
                    >
                        <CustomContainer
                            width="67.5" sizeUnit="%"
                            className='dashboard-chart-wrapper' 
                        >
                            <CustomContainer
                                minHeight="50" radius="0.4"
                                padding="2.5" bgColor="#ffffff"
                                shadow='0px 10px 50px 0px #0000000D'
                            >
                                <AppSpan textSize="1.6" color="#181D27" fontWeight="700">
                                    Company Information
                                </AppSpan>
                                <FlexRow 
                                    topMargin="2" wrap="wrap"
                                    justifyContent="space-between" 
                                    gap="5" alignItems="flex-start"
                                >
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Company Name</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.name}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Email Address</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.email}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Date Incorporated</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.dateOfIncorporation ? helpers.splitDateTime(company?.dateOfIncorporation)?.date : ''}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Phone Number</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.phoneNumber}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Phone Number 2</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">--</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Official Website</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.officialWebsite}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Official Address</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.address}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>City</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.city}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>State</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.state}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20" sizeUnit="">
                                        <AppSpan>Country</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.country}</AppText>
                                    </CustomContainer>
                                </FlexRow>
                            </CustomContainer>
                            
                            <CustomContainer
                                minHeight="35.2" radius="0.4"
                                padding="2.5" bgColor="#ffffff"
                                shadow='0px 10px 50px 0px #0000000D'
                                topMargin='2'
                            >
                                <AppSpan textSize="1.6" color="#181D27" fontWeight="700">
                                    Subscription
                                </AppSpan>
                                <FlexRow 
                                    alignItems="flex-start" wrap="wrap"
                                    bottomPadding="2.5" topMargin="3" gap="2"
                                    style={{borderBottom: '1px solid #E0E0E0'}}
                                >
                                    <CustomContainer width="20">
                                        <AppSpan>Subscription Plan</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.subscriptionPlan}</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="20">
                                        <AppSpan>Subscription Duration</AppSpan>
                                        <AppText color="#1D1D1D" fontWeight="500">{company?.subscriptionTime} year</AppText>
                                    </CustomContainer>
                                    <CustomContainer width="auto" sizeUnit="">
                                        <AppSpan>Subscription Status</AppSpan>
                                        <GridContainer 
                                            width='10' sizeUnit="" minHeight='2.7' topMargin="0.5"
                                            bgColor={company?.active ? '#D9FFE9' : '#FFF0F0'} 
                                            topPadding='0' bottomPadding='0' padding='0.8' radius='1.35'
                                        >
                                            <AppSpan 
                                                color={company?.active ? '#27AE60' : '#EB5757'} 
                                                fontWeight='500'
                                            >
                                                {company.active ? 'Active' : 'Suspended'}
                                            </AppSpan>
                                        </GridContainer>
                                    </CustomContainer>
                                </FlexRow>
                                <CustomContainer topMargin="2.5">
                                    <AppSpan textSize="1.6" color="#181D27" fontWeight="600">
                                        Services Subscribed
                                    </AppSpan>
                                    <FlexRow gap="2" wrap="wrap" topMargin="3">
                                        <CustomContainer width="20">
                                            <AppSpan color="#333333">Address pinpoint service</AppSpan>
                                            <AppText color="#27AE60" fontWeight="700">Running</AppText>
                                        </CustomContainer>
                                        <CustomContainer width="20">
                                            <AppSpan color="#333333">Server pinpoint service</AppSpan>
                                            <AppText color="#27AE60" fontWeight="700">Running</AppText>
                                        </CustomContainer>
                                    </FlexRow>
                                </CustomContainer>

                                <Button 
                                    width='18.5' 
                                    hoverBgColor='#5627FF' 
                                    hoverColor='#ffffff'
                                    color="#5627FF"
                                    bgColor="#ffffff"
                                    borderColor='#5627FF'
                                    topMargin="5"
                                >
                                    End Subscription
                                </Button>
                            </CustomContainer>

                            <CustomContainer
                                minHeight="35.2" radius="0.4"
                                padding="2.5" bgColor="#ffffff"
                                shadow='0px 10px 50px 0px #0000000D'
                                topMargin='2'
                            >
                                <AppSpan textSize="1.6" color="#181D27" fontWeight="700">
                                    Document
                                </AppSpan>
                                <FlexRow gap='3' wrap="wrap" alignItems='flex-start'>
                                    <CustomContainer 
                                        width='35.7' height='23.4' 
                                        radius='0.4' borderColor='#000000'
                                    >
                                        <img src={SubsidiaryDoc} className='img-child'/>
                                    </CustomContainer>
                                    <CustomContainer width='auto' sizeUnit=''>
                                        <CustomContainer width="20" sizeUnit="" bottomMargin='2'>
                                            <AppSpan>Registration Number</AppSpan>
                                            <AppText color="#1D1D1D" fontWeight="500">299388299278</AppText>
                                        </CustomContainer>
                                        <CustomContainer width="20" sizeUnit="">
                                            <AppSpan>Verification Status</AppSpan>
                                            <AppText color="#1D1D1D" fontWeight="500">Verified</AppText>
                                        </CustomContainer>
                                    </CustomContainer>
                                </FlexRow>
                            </CustomContainer>
                        </CustomContainer>

                        <CustomContainer 
                            width="30" sizeUnit="%" topMargin="5"
                            className='dashboard-chart-wrapper remove-1100'
                        >
                            <AbsoluteContainer 
                                top="-5" left="50" lSizeUnit="%"
                            >
                                <Circle 
                                    size="8" 
                                    borderColor="#E0E0E0" 
                                    bgColor="#ffffff"
                                >
                                    <SubscriptionIcon className='icon-component' />
                                </Circle>
                            </AbsoluteContainer>
                            <FlexRow 
                                borderColor="#E0E0E0" 
                                minHeight="12.7" 
                                radius="0.4" 
                                padding="2"
                                topPadding="4"
                                gap="2.5"
                                wrap="wrap"
                                bgColor="#ffffff"
                                justifyContent="space-between"
                            >
                                <CustomContainer width="auto" sizeUnit="">
                                    <AppSpan>Subscription</AppSpan>
                                    <AppText color="#282828" fontWeight="700">Paid Plan</AppText>
                                </CustomContainer>
                                <CustomContainer width="auto" sizeUnit="">
                                    <AppSpan>Status</AppSpan>
                                    <AppText color="#27AE60" fontWeight="700">Running</AppText>
                                </CustomContainer>
                            </FlexRow>
                        </CustomContainer>
                    </FlexRow>
                    :
                    <CustomContainer 
                        topMargin={subsidiaries?.length ? '3' : '0'}
                        className='no-user-container'
                    >
                        <ServerSideTable
                            //tableColumns={subsidiariesColumn(true, handleSubsidiaryRowClick)}
                            tableColumns={subsidiariesColumn(false)}
                            tableData={subsidiaries}
                            dataFetchMethod={handleFetchSubsidiaries}
                            totalRows={subsidiariesInfo?.totalResults}
                            noRadius
                            //onRowClickMethod={handleRowClick}
                            noDataText={
                                <>
                                    <AppText 
                                        textSize="1.6" 
                                        color="#000000" 
                                        fontWeight="700"
                                        align='center'
                                    >
                                        No subsidiaries added yet
                                    </AppText>
                                    <AppSpan textSize="1.6" color="#000000" align='center'>
                                        You have not added any subsidiaries yet. 
                                    </AppSpan>
                                </>
                            }
                            noDataCustomIcon={ <NoUserIcon className="icon-component" /> }
                        />
                    </CustomContainer>
                }
            </ScreenContainer>
        </>
    )
}

export default utility.routeData('companies/company-details', 'Company Details', <CompanyDetails/>)